import "./App.css";
import Homepage from "./pages/Homepage";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import "./styles/style.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import Register from "./pages/Register";
import LoginPage from "./pages/LoginPage";
import NotFound from "./pages/NotFound";
import { Authentication } from "./useAuth";
import { ProfilePage } from "./pages/ProfilePage";
import AppAuth from "./AppAuth";
import Contact from "./pages/contacts/Contact";
import ContactsList from "./pages/contacts/ContactsList";
import RequireAuth from "./Components/global/RequireAuth";

// Lists
import DepartmentList from "./pages/departments/DepartmentList";
import StudentList from "./pages/students/StudentList";
import EmployeeList from "./pages/employees/EmployeeList";
import EmployeeRegistration from "./pages/employees/EmployeeRegistration";
import GenerateEmployeeIdCard from "./pages/employees/GenerateEmployeeIdCard";
import EmployeeAttendance from "./pages/employees/EmployeeAttendance";
import GenerateExperienceCertificate from "./pages/employees/GenerateExperienceCertificate";
import ExperienceCertificateList from "./pages/employees/ExperienceCertificateList";
import NoticeList from "./pages/notices/NoticeList";
import WhatsAppAlertsPage from "./pages/communication/WhatsAppAlertsPage";
import RoleList from "./pages/roles/RoleList";
import ModuleManagementPage from "./pages/modules/ModuleManagementPage";
import UserList from "./pages/users/UserList";
import StudentRegistration from "./pages/students/StudentRegistration";
import GenerateIdCard from "./pages/students/GenerateIdCard";
import TransferCertificateList from "./pages/students/TransferCertificateList";
import GenerateTransferCertificate from "./pages/students/GenerateTransferCertificate";
import SubjectList from "./pages/subjects/SubjectList";
import ExpenseList from "./pages/expenses/ExpenseList";
import ExpenseDashboard from "./pages/expenses/ExpenseDashboard";
import FeeStructureList from "./Components/lists/FeeStructureList";
import StudentFeeList from "./Components/lists/StudentFeeList";
import GalleryPage from "./pages/gallery/GalleryPage";
import EventsPage from "./pages/events/EventsPage";

// Enterprise Fee Management
import FeeDashboardPage from "./pages/fees/FeeDashboardPage";
import AssignStudentFeePage from "./pages/fees/AssignStudentFeePage";
import CollectFeePage from "./pages/fees/CollectFeePage";
import FeeReceiptsRegisterPage from "./pages/fees/FeeReceiptsRegisterPage";
import StudentFeeProfilePage from "./pages/fees/StudentFeeProfilePage";
import UpcomingDueFeesPage from "./pages/fees/UpcomingDueFeesPage";
import FeeCategoriesPage from "./pages/fees/FeeCategoriesPage";
import FeeReportsPage from "./pages/fees/FeeReportsPage";
import FeeSettingsPage from "./pages/fees/FeeSettingsPage";

export default function App() {
  const Scroll = (props) => {
    const location = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);
    return props.children;
  };

  return (
    <div>
      <ToastContainer position="top-right" />
      <Authentication>
        <Scroll>
          <div className="text-sm text-slate-600">
            <Routes>
              <Route path="login" element={<LoginPage />} />
              <Route path="register" element={<Register />} />
              <Route path="*" element={<NotFound />} />
              <Route path="/" element={<Navigate to="/my" />} />
              <Route path="/my" element={<AppAuth />}>
                <Route
                  path=""
                  element={
                    <RequireAuth
                      component={<Homepage />}
                      moduleCode="DASHBOARD"
                    />
                  }
                />
                <Route path="profile" element={<ProfilePage />} />

                {/* Telecaller */}
                <Route
                  path="telecaller"
                  element={
                    <RequireAuth
                      component={<Contact />}
                      userTypes={["admin", "telecaller"]}
                    />
                  }
                />

                <Route
                  path="contactsList"
                  element={
                    <RequireAuth
                      component={<ContactsList />}
                      userTypes={["admin"]}
                    />
                  }
                />

                {/* Academics */}
                <Route
                  path="departments"
                  element={
                    <RequireAuth
                      component={<DepartmentList />}
                      userTypes={["admin"]}
                    />
                  }
                />

                {/* People Management */}
                <Route
                  path="students"
                  element={
                    <RequireAuth
                      component={<StudentList />}
                      userTypes={["admin", "teacher", "staff"]}
                    />
                  }
                />

                <Route
                  path="students/register"
                  element={
                    <RequireAuth
                      component={<StudentRegistration />}
                      userTypes={["admin", "teacher", "staff"]}
                    />
                  }
                />

                <Route
                  path="students/edit/:id"
                  element={
                    <RequireAuth
                      component={<StudentRegistration />}
                      userTypes={["admin", "teacher", "staff"]}
                    />
                  }
                />

                <Route
                  path="students/id-card"
                  element={
                    <RequireAuth
                      component={<GenerateIdCard />}
                      userTypes={["admin", "teacher", "staff"]}
                    />
                  }
                />

                <Route
                  path="students/transfer-certificates"
                  element={
                    <RequireAuth
                      component={<TransferCertificateList />}
                      userTypes={["admin", "teacher", "staff"]}
                    />
                  }
                />

                <Route
                  path="students/generate-tc"
                  element={
                    <RequireAuth
                      component={<GenerateTransferCertificate />}
                      userTypes={["admin", "teacher", "staff"]}
                    />
                  }
                />

                <Route
                  path="employees"
                  element={
                    <RequireAuth
                      component={<EmployeeList />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="employees/register"
                  element={
                    <RequireAuth
                      component={<EmployeeRegistration />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="employees/id-card"
                  element={
                    <RequireAuth
                      component={<GenerateEmployeeIdCard />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="employees/edit/:id"
                  element={
                    <RequireAuth
                      component={<EmployeeRegistration />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="employees/attendance"
                  element={
                    <RequireAuth
                      component={<EmployeeAttendance />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="employees/generate-exp-cert"
                  element={
                    <RequireAuth
                      component={<GenerateExperienceCertificate />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="employees/experience-certificates"
                  element={
                    <RequireAuth
                      component={<ExperienceCertificateList />}
                      userTypes={["admin"]}
                    />
                  }
                />

                {/* Communication */}
                <Route
                  path="notices"
                  element={
                    <RequireAuth
                      component={<NoticeList />}
                      moduleCode="NOTICES"
                    />
                  }
                />

                <Route
                  path="whatsapp"
                  element={
                    <RequireAuth
                      component={<WhatsAppAlertsPage />}
                      moduleCode="WHATSAPP_ALERTS"
                    />
                  }
                />

                <Route
                  path="gallery"
                  element={
                    <RequireAuth
                      component={<GalleryPage />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="events"
                  element={
                    <RequireAuth
                      component={<EventsPage />}
                      userTypes={["admin"]}
                    />
                  }
                />

                {/* Settings */}
                <Route
                  path="roles"
                  element={
                    <RequireAuth
                      component={<RoleList />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="modules"
                  element={
                    <RequireAuth
                      component={<ModuleManagementPage />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="subjects"
                  element={
                    <RequireAuth
                      component={<SubjectList />}
                      userTypes={["admin", "teacher"]}
                    />
                  }
                />

                <Route
                  path="expenses"
                  element={
                    <RequireAuth
                      component={<ExpenseList />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="expenses/dashboard"
                  element={
                    <RequireAuth
                      component={<ExpenseDashboard />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="fee-structures"
                  element={
                    <RequireAuth
                      component={<FeeStructureList />}
                      userTypes={["admin", "teacher"]}
                    />
                  }
                />

                <Route
                  path="student-fees"
                  element={
                    <RequireAuth
                      component={<StudentFeeList />}
                      userTypes={["admin"]}
                    />
                  }
                />

                {/* Enterprise Fee Management Routes */}
                <Route
                  path="fees/dashboard"
                  element={
                    <RequireAuth
                      component={<FeeDashboardPage />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="fees/assign"
                  element={
                    <RequireAuth
                      component={<AssignStudentFeePage />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="fees/collect"
                  element={
                    <RequireAuth
                      component={<CollectFeePage />}
                      userTypes={["admin", "staff"]}
                    />
                  }
                />
                <Route
                  path="fees/receipts"
                  element={
                    <RequireAuth
                      component={<FeeReceiptsRegisterPage />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="fees/ledger"
                  element={
                    <RequireAuth
                      component={<StudentFeeProfilePage />}
                      userTypes={["admin", "teacher"]}
                    />
                  }
                />
                <Route
                  path="fees/defaulters"
                  element={
                    <RequireAuth
                      component={
                        <UpcomingDueFeesPage isDefaultersOnly={true} />
                      }
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="fees/categories"
                  element={
                    <RequireAuth
                      component={<FeeCategoriesPage />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="fees/reports"
                  element={
                    <RequireAuth
                      component={<FeeReportsPage />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="fees/settings"
                  element={
                    <RequireAuth
                      component={<FeeSettingsPage />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="users"
                  element={
                    <RequireAuth
                      component={<UserList />}
                      userTypes={["admin"]}
                    />
                  }
                />
              </Route>
            </Routes>
          </div>
        </Scroll>
      </Authentication>
    </div>
  );
}
